import styled from '@emotion/styled';
import {
  bodyM,
  captionM,
  captionSb,
  subTitle2,
  subTitle3,
  title2,
} from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
  * {
    margin: 0;
  }
`;
export const Title = styled.h2`
  ${subTitle2};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    ${title2};
    color: ${vars.neutral[0]};
  }
`;
export const LecturerContainer = styled.div`
  display: flex;
  gap: 20px;
  ${DESKTOP} {
    gap: 40px;
  }
`;
export const LectureImgWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 123px;
  height: 159px;
  border-radius: 12px;
  overflow: hidden;
  ${DESKTOP} {
    border-radius: 20.5px;
    width: 264px;
    height: 320px;
  }
`;
export const LectureInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
export const LectureSaying = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  white-space: pre-wrap;
  ${subTitle3};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    gap: 16px;
    ${subTitle2};
    color: ${vars.neutral[0]};
  }
`;
export const LectureHistory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${DESKTOP} {
    gap: 12px;
  }
`;
export const LectureName = styled.p`
  ${subTitle3};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    ${subTitle2};
    color: ${vars.neutral[0]};
  }
`;
export const LectureCareers = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
export const LectureCareer = styled.p`
  ${captionM};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[0]};
  }
`;
export const LectureChannels = styled.div``;
export const LectureChannel = styled.a`
  display: flex;
  gap: 4px;
  align-items: center;
  ${captionSb};
  color: #2958ff;
  ${DESKTOP} {
    ${captionSb};
    color: #2958ff;
  }
`;
